import { useState } from "react";
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import MapboxGLMap from './MapboxGLMap';

export default function SrchResults(props) {
  const {	requestBbox, stationList, userParams, setUserParams, setShowSearchMore, setEnteredSid, setShowGoButton } = props;
  const [ selectedStnIndx, setSelectedStnIndx ] = useState("");

  const updateStation = (event) => {
    const indx = event.target.value >= 0 ? event.target.value : event.currentTarget.value;
    const stn = stationList[indx];
    setSelectedStnIndx(indx);
    setUserParams({...userParams, sid: stn.id.split(" ")[0], stnName: stn.name_and_vdr});
    setEnteredSid(stn.id.split(" ")[0]);
    setShowSearchMore(false);
    setShowGoButton(true);
  }

  const clickStation = (stn) => {
    setUserParams({...userParams, sid: stn.id.split(" ")[0], stnName: stn.name_and_vdr});
    setEnteredSid(stn.id.split(" ")[0]);
    setShowSearchMore(false);
    setShowGoButton(true);
  }

  return (      
    <Box 
      sx={{ mt: 1 }}
    >
      {stationList.length === 1 &&
        <Stack direction="row" spacing={1}>
          <Typography>
            Nearest: {stationList[0].name_and_vdr}
          </Typography>
          <Button 
            value={0}
            size="small"
            variant="contained"
            color="primary"
            onClick={updateStation}
          >
            Use this station
          </Button>
        </Stack>
      }
      {stationList.length > 1 &&
        <>
          <Stack direction="row" spacing={1}>
            <Typography>
              Nearby stations:
            </Typography>
            <FormControl size="small">
              <InputLabel id="station-select-label">Select station</InputLabel>
              <Select 
                labelId="station-select-label"
                value={selectedStnIndx}
                label="Select station"
                onChange={updateStation}
              >
                {stationList.map((sta, index) => (
                  <MenuItem 
                    key={index} 
                    value={index} 
                    dense={true} 
                    sx={{lineHeight:1, minHeight:24}}
                  >
                    {sta.name_and_vdr}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>Select from meunu or click station on map ...</FormHelperText>
            </FormControl>
          </Stack>

          <Box sx={{ height: 502, width: 500, border: 1 }}>
            <MapboxGLMap
                markers={stationList}
                requestBbox={requestBbox}
                clickStation={clickStation}
                mapsize={500}
            />
          </Box>
        </>
     }
    </Box>
  )
}